import { Map } from 'immutable';
import { IGrantee } from '@opengov/reporting-types';
import React from 'react';
import { ILocalized } from '../../../src/locale/types';
import { Box } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { styles } from './ReportSettings.styles';

export interface IColumnDef {
  headerName: string;
  field: string;
  headerComponentParams: {
    isSorted: boolean;
  };
  width?: number;
  valueGetter?: (params: string) => string;
  renderCell?: (params) => JSX.Element;
}

export interface IReportAccessGridProps extends ILocalized {
  granteeRows: Map<string, IGrantee>;
  columnDefs: IColumnDef[];
}

export const ReportAccountSummaryAccessGrid = (props: IReportAccessGridProps) => {
  const { granteeRows, columnDefs } = props;

  const rows: {
    granteeName: string;
    granteeEmail: string;
    actionSet: string | undefined;
    id: string;
    granteeType: string;
    granteeId: string;
  }[] = [];
  granteeRows.forEach((grantee) => {
    rows.push({
      granteeType: grantee.granteeType,
      granteeName: grantee.granteeName,
      granteeEmail: grantee.granteeEmail,
      granteeId: grantee.granteeId,
      actionSet: grantee.actionSet,
      // Use DB primary key when present; otherwise fall back to granteeId for new/default rows.
      id: grantee.id ?? grantee.granteeId
    });
  });

  const columns: GridColDef<{
    granteeName: string;
    granteeEmail: string;
    actionSet: string | undefined;
    id: string;
  }>[] = [];
  columnDefs.forEach((columnDef) => {
    columns.push({
      field: columnDef.field,
      headerName: columnDef.headerName,
      width: columnDef.width ?? 200,
      sortable: true,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      valueGetter: (value) => columnDef.valueGetter?.(value),
      renderCell: columnDef.renderCell ?? ((param) => param.value)
    });
  });

  return (
    <Box sx={styles.tableContainer}>
      <DataGrid
        data-test="report-access-grid"
        rows={rows}
        columns={columns}
        columnVisibilityModel={{
          granteeType: false // Hide 'email' column
        }}
        density={'standard'}
        hideFooterPagination={true}
        hideFooter={true}
        checkboxSelection={false}
        disableRowSelectionOnClick
      />
    </Box>
  );
};
